<ng-template #bannerBody>
  @if (configsStorage.config.WEB_BANNER_URL) {
    <div><img [src]="configsStorage.config.WEB_BANNER_URL"
    [width]="configsStorage.config.WEB_BANNER_WIDTH ? +configsStorage.config.WEB_BANNER_WIDTH : 910" /></div>
  }
  @if (!configsStorage.config.WEB_BANNER_URL) {
    <div [innerHTML]="'BANNER_CONTENT_HTML' | translate"></div>
  }
</ng-template>